module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier-sp@2x.ff549b96.jpg";